// src/app/features/toronto/toronto.module.ts
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';

// Toronto components
import {TorontoDashboardComponent} from './components/dashboard/toronto-dashboard.component';
import {TorontoListingsSearchComponent} from './components/search-filter/toronto-listings-search.component';
import {TorontoListingDetailsFullComponent} from './components/listing-details/toronto-listing-details-full.component';

// Toronto services
import {TorontoListingsService} from './services/toronto-listings.service';
import {TorontoRoutingModule} from "./toronto-routing.module";
import {LISTINGS_SERVICE_TOKEN} from "../../core/services/listings-service.token";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    TorontoRoutingModule,

    // Standalone components
    TorontoDashboardComponent,
    TorontoListingDetailsFullComponent,
    TorontoListingsSearchComponent,
  ],
  providers: [
    TorontoListingsService,
    {provide: LISTINGS_SERVICE_TOKEN, useClass: TorontoListingsService}
  ]
})
export class TorontoModule {
}
